export enum TprmSchemaDisplayFormat {
    checkbox = 'CHECKBOX',
    collateral = 'COLLATERAL',
    collaterals = 'COLLATERALS',
    currency = 'CURRENCY',
    days = 'DAYS',
    months = 'MONTHS',
    hidden = 'HIDDEN',
    insuredField = 'INSURED_FIELD',
    country = 'COUNTRY',
    address = 'ADDRESS',
    sortableList = 'SORTABLE_LIST',
    multiLine = 'MULTI_LINE',
    radioButtons = 'RADIO_BUTTONS',
    andOrGroup = 'AND_OR_GROUP',
    equipment = 'EQUIPMENT',
    equipmentItem = 'EQUIPMENT_ITEM',
}
